export default "__VITE_ASSET__DLW2VeqF__"